import React, { useMemo } from 'react';
import { TerminalWindow, ArrowsCounterClockwise, EyeSlash } from '@phosphor-icons/react';

interface BotLogViewerProps {
  logsContent: string;
  isOpen: boolean;
  onClose: () => void;
  onRefresh?: () => void;
}

const stripAnsi = (str: string): string => {
  // eslint-disable-next-regex
  return str.replace(/[\u001b\u009b][\[()#;?]*(?:[0-9]{1,4}(?:;[0-9]{0,4})*)?[0-9A-ORZcf-n outcome]/g, '');
};

export const BotLogViewer: React.FC<BotLogViewerProps> = ({
  logsContent,
  isOpen,
  onClose,
  onRefresh,
}) => {
  const cleanLogs = useMemo(() => stripAnsi(logsContent || ''), [logsContent]);

  if (!isOpen) return null;

  return (
    <div className="mt-4 rounded-lg border border-slate-700 bg-slate-950 p-4 font-mono text-xs text-green-400 shadow-inner">
      <div className="mb-2 flex items-center justify-between border-b border-slate-800 pb-2 text-slate-400">
        <div className="flex items-center gap-1.5 font-semibold text-slate-200">
          <TerminalWindow size={18} className="text-green-400" />
          <span>Console Logs</span>
        </div>
        <div className="flex items-center gap-2">
          {onRefresh && (
            <button
              onClick={onRefresh}
              className="flex items-center gap-1 rounded px-2 py-1 text-xs text-slate-300 hover:bg-slate-800"
            >
              <ArrowsCounterClockwise size={14} />
              <span>Tải lại</span>
            </button>
          )}
          <button
            onClick={onClose}
            className="flex items-center gap-1 rounded px-2 py-1 text-xs text-slate-300 hover:bg-slate-800"
          >
            <EyeSlash size={14} />
            <span>Ẩn Log</span>
          </button>
        </div>
      </div>
      <pre className="max-h-80 overflow-y-auto whitespace-pre-wrap rounded bg-black/50 p-3 leading-relaxed">
        {cleanLogs || 'Không có dữ liệu log.'}
      </pre>
    </div>
  );
};